import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import {
  InventorySetupHelp,
  NotesHelp,
  HistoryHelp,
} from "./InventoryHelpComponents";

const useStyles = makeStyles(() => ({
  icon: {
    verticalAlign: "middle",
    display: "inline-flex",
  },
}));

export const InventoryHelp = (props) => {
  const classes = useStyles();
  const tabNames = props?.location.pathname.split("/");
  const tab = tabNames?.length > 3 ? tabNames[3] : "";

  switch (tab) {
    case "":
      return <InventorySetupHelp classes={classes} />;
    case "notes":
      return <NotesHelp classes={classes} />;
    case "historyLogs":
      return <HistoryHelp classes={classes} />;
    default:
      return null;
  }
};
